/* Plan catalogue shown on the marketing home, /pricing and in-app billing.
 * Prices come from the API on authenticated pages (BillingView.planPrices);
 * public pages use the published defaults below (same as seed planPrices). */
import type { Cycle } from "../../../data/types";
import { subAmount } from "../../../domain/compliance";

export const DEFAULT_PRICES: Record<string, number> = { Starter: 19, Business: 29, Pro: 45 };
export const PLANS = ["Starter", "Business", "Pro"] as const;
export type PlanName = (typeof PLANS)[number];
export const ANNUAL_DISCOUNT = 0.2;
export const TRIAL_DAYS = 30;

type Bi = [string, string];
export const PLAN_INFO: Record<PlanName, { limit: Bi; features: Bi[] }> = {
  Starter: {
    limit: ["Up to 10 employees", "حتى 10 موظفين"],
    features: [["Employee records & documents", "سجلات الموظفين والوثائق"], ["Payroll with GOSI calculation", "الرواتب مع احتساب التأمينات"], ["Leave management", "إدارة الإجازات"], ["Arabic & English", "العربية والإنجليزية"]],
  },
  Business: {
    limit: ["Up to 100 employees", "حتى 100 موظف"],
    features: [["Everything in Starter", "كل ما في Starter"], ["WPS (Mudad) & GOSI exports", "تصدير حماية الأجور والتأمينات"], ["Employee self-service app", "تطبيق الخدمة الذاتية"], ["Attendance with geofencing & biometric devices", "الحضور بالنطاق الجغرافي وأجهزة البصمة"], ["Loans, letters & EOSB", "القروض والخطابات ونهاية الخدمة"]],
  },
  Pro: {
    limit: ["Up to 250 employees", "حتى 250 موظفًا"],
    features: [["Everything in Business", "كل ما في Business"], ["Saudization tools & simulator", "أدوات ومحاكي التوطين"], ["Multi-branch & multi-CR", "تعدد الفروع والسجلات"], ["Custom roles & approvals", "أدوار واعتمادات مخصصة"], ["API & ERP integration", "واجهة برمجية وتكامل ERP"]],
  },
};

/** Displayed per-employee monthly price for a cycle (annual = −20%, rounded like the prototype). */
export const perEmployee = (price: number, cycle: Cycle) => (cycle === "y" ? Math.round(price * (1 - ANNUAL_DISCOUNT)) : price);

/** Safe wrapper around the domain calculator (unknown plan → zeros). */
export function quote(prices: Record<string, number>, plan: string, cycle: Cycle, seats: number, aiPack = 0) {
  try { return subAmount(prices, plan, cycle, seats, aiPack); } catch { return { amount: 0, vat: 0, total: 0 }; }
}
